/*
    Will convert: "Go Out There" to "GO"
*/
import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({ name: 'appLabel' })
@Pipe({ name: 'wordsFirstLetter' })
export class WordsFirstLetterPipe implements PipeTransform {
    transform(value: string, limit: number = 2): string {
        if (!value) return value;
        return value.split(' ').reduce((acc, word, index) => {
            if (index > (limit - 1)) return acc;
            return acc += word[0].toUpperCase();
        }, '');
    }
}
